import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../../service/order.service';
import { RatingComponent } from '../rating-modal.component';

@Component({
  selector: 'app-rating-modal-mobile',
  templateUrl: './rating-modal-mobile.component.html',
  styleUrls: ['./rating-modal-mobile.component.scss']
})
export class RatingModalMobileComponent extends RatingComponent {

  constructor(
    orderService: OrderService,
    modalService: NgbModal,
    router: Router,
    activeModal: NgbActiveModal,
  ) {
    super(
      orderService,
      modalService,
      router,
      activeModal
    )
  }


}
